<h2>Edit pages</h2>

<div fxLayout="column wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">

        <mat-form-field appearance="outline" fxFlex="33">
            <mat-label>Page Number</mat-label>
            <mat-select  [(ngModel)]="PageNumber">
                <mat-option *ngFor="let item of printPagesList" [value]="item?.Id"
                    class="badge-dropdown">
                    <span>{{item?.PageFrom}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
</div>

<mat-card-actions fxLayout="row" fxLayoutAlign="end" class="edit-offer-tags-popup-actions">
    <button mat-stroked-button type="button" (click)="closeDialog()">
        Cancel
    </button>
    <button mat-raised-button type="button" color="accent" (click)="savePage()">
        Save
    </button>
</mat-card-actions>